<template>
    <span class="yesNo">{{ params.value | yesNo() }}</span>
</template>

<script>
  import Vue from "vue";

  export default Vue.extend({
    filters: {
      yesNo(value) {
        return value ? 'Yes' : 'No';
      }
    }
  });
</script>
